"use client"; // Error components must be Client Components

import { useEffect } from "react";

import { useAnalytics } from "@/app/components/AnalyticsProvider";
import ErrorPane from "@/app/deb/components/ErrorPane";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string; captureStackTrace: (obj: object) => string };
  reset: () => void;
}) {
  const analytics = useAnalytics();

  // If the error is an error object that has a message, we can log it
  const errorMessage = error instanceof Error && error.message ? error.message : "";
  if (error.captureStackTrace && !error.stack) {
    error.stack = error.captureStackTrace ? error.captureStackTrace(error) : "";
  }

  useEffect(() => {
    analytics.triggerErrorReport(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <div className="h-full w-full bg-base-100">
      <div className="p-4 h-full w-full flex flex-col items-start">
        <ErrorPane
          severity="fatal"
          recoveryMode="hardlink"
          message="An error has occurred that we didn't expect. We've reported this to our engineers and we'll get on the case fixing it."
          onClickRetry={() => reset()}
          smallPrint={`${errorMessage}${error.stack}`}
        />
      </div>
    </div>
  );
}
